<template>
  <OmitBlock
    :element="sectionElement"
    :entryItems="entryItems"
    @updated="updated($event)"
  >
    <div :class="sectionElement.style">
      <root-element
        :rootElement="sectionElement"
        :entryItems="entryItems"
        v-if="sectionElement"
        @updated="updated($event)"
      />
    </div>
  </OmitBlock>
</template>

<script>
import OmitBlock from "@/components/document/generator/OmitBlock";
export default {
  name: "SectionElement",
  props: ["sectionElement", "entryItems"],
  components: {
    OmitBlock
  },
  methods: {
    updated(event) {
      this.$emit("updated", event);
    }
  }
};
</script>
